function path(root: string, sublink: string) {
  return `${root}/${sublink}`.replace('///', '/').replace('//', '/');
}

const ROOT = '/';
const ROOT_PATH = path(ROOT, '');

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOT_PATH,
  login: path(ROOT_PATH, 'login'),
  verify: path(ROOT_PATH, 'verify'),
  register: path(ROOT_PATH, 'register'),
  findId: path(ROOT_PATH, 'find-user'),
  newPassword: path(ROOT_PATH, 'new-password'),
  resetPassword: path(ROOT_PATH, 'reset-password'),
  loginUnprotected: path(ROOT_PATH, 'login-unprotected'),
  registerUnprotected: path(ROOT_PATH, 'register-unprotected'),
};

export const PATH_SUB = {
  root: ROOT_PATH,
  home: ROOT_PATH,
  management: path(ROOT_PATH, 'management'),
  adminManagement: path(ROOT_PATH, 'admin-management'),
};

export const PATH_PAGE = {
  page403: path(ROOT_PATH, '403'),
  page404: path(ROOT_PATH, '404'),
  page500: path(ROOT_PATH, '500'),
  comingSoon: path(ROOT_PATH, 'coming-soon'),
  maintenance: path(ROOT_PATH, 'maintenance'),

  management: {
    recruit: path(PATH_SUB.management, 'recruit'),
    contents: {
      root: path(path(PATH_SUB.management, 'contents'), 'mainVisual'),
      popup: path(path(PATH_SUB.management, 'contents'), 'popup'),
      mainVisual: path(path(PATH_SUB.management, 'contents'), 'mainVisual'),
      business: path(path(PATH_SUB.management, 'contents'), 'business'),
      category: path(path(PATH_SUB.management, 'contents'), 'category'),
    },
    company: {
      root: path(PATH_SUB.management, 'company'),
      history: path(path(PATH_SUB.management, 'company'), 'history'),
      partner: path(path(PATH_SUB.management, 'company'), 'partner'),
      settings: path(path(PATH_SUB.management, 'company'), 'settings'),
    },
    ir: {
      root: path(PATH_SUB.management, 'ir'),
      event: path(path(PATH_SUB.management, 'ir'), 'event'),
      materials: path(path(PATH_SUB.management, 'ir'), 'materials'),
    },
    pr: {
      root: path(PATH_SUB.management, 'pr'),
      news: path(path(PATH_SUB.management, 'pr'), 'news'),
      notice: path(path(PATH_SUB.management, 'pr'), 'notice'),
    },
  },
  adminManagement: {
    menu: path(PATH_SUB.adminManagement, 'menu'),
    group: path(PATH_SUB.adminManagement, 'group'),
    employee: path(PATH_SUB.adminManagement, 'employee'),
  },
  guide: {
    root: path(PATH_SUB.management, 'guide'),
  },
};
